import { appConfig } from '@common/config';
import { DETAIL_STATE } from '@constants/common';
import { type IDetailIndexPorps, type IDetailItemDicInfo } from '@interface/IDetail';
import { itemInfoQueryKey } from '@network/queryKeys';
import { useDataQuery } from '@network/querys';
import { keepPreviousData } from '@tanstack/react-query';
import classNames from 'classnames';
import { useState } from 'react';
import { FolderBtn } from '../FolderBtn';

export const SecDecompSrc = ({ props }: { props: IDetailIndexPorps }) => {
    // const { t } = useTranslation();
    // const setParams = useSetSearchParams();
    const [isFolderOepn, isFolderOepnSet] = useState(true);

    const { data: iteminfo } = useDataQuery<IDetailItemDicInfo>(
        itemInfoQueryKey,
        `/${appConfig.service}/v2.0/game/item/${props.detailId}`,
        { level: props.detailLevel },
        {
            staleTime: 5000,
            placeholderData: keepPreviousData,
            enabled: props.detailNow === DETAIL_STATE.ITEM && !!props.detailId,
        }
    );

    if (!iteminfo?.name || !iteminfo.sources || iteminfo.sources.length < 1) return null;

    const optionList = iteminfo.sources?.map((op, idx) => (
        <li key={idx}>
            <div className="value">{op}</div>
        </li>
    ));

    return (
        <section className="decompsrc" style={{ display: 'block' }}>
            <header>
                <h3>획득처</h3>
                <FolderBtn isFolderOepn={isFolderOepn} isFolderOepnSet={isFolderOepnSet} />
            </header>
            <article className={classNames({ 'is-active': isFolderOepn }, 'gameinfo-dict')}>
                <div className="gameinfo-loader">
                    <span className="loader" />
                </div>
                <ul>{optionList}</ul>
            </article>
        </section>
    );
};
